export default "__VITE_ASSET__Dla0xrrP__"